import { z } from "zod";

// This is not fully typed as we do not need - normally - the full operator DTO
// You can add missing fields if you need
export const operatorDtoSchema = z.object({
  id: z.number().nullable(),
  firstname: z.string().nullable(),
  lastname: z.string().nullable(),
});

export type TOperatorDto = z.infer<typeof operatorDtoSchema>;
